import type { ReactNode } from 'react';

/** Üst menü: modüller header'ın orta alanında dropdown olarak (TopNavBar AppHeader `center` slot'una verilir). */
export function TopNavLayout({ children }: { children: ReactNode }) {
  return <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">{children}</main>;
}
